import config from '@/config'
export default {
	methods: {
		money(amount, currency) {
			let ratio = config.currency[currency] || 1
			return parseFloat(amount/ratio)
		},
	    youtube_parser(url){
		    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		    var match = url.match(regExp);
		    return (match&&match[7].length==11)? match[7] : false;
		}
	},
	computed: {

	},
	filters: {
		formatDate(timestamp, show_hour = true) {
		  if ( !timestamp ) return ''
		  function add_zero(num) { return num < 10 ? ('0' + num) : num; }
		  let date = new Date(timestamp * 1000);
		  let formated = [date.getFullYear(), add_zero(date.getMonth() + 1), add_zero(date.getDate())].join("-");
		  let hours = [add_zero(date.getHours()), add_zero(date.getMinutes()), add_zero(date.getSeconds())].join(":");
		  return formated + (show_hour ? (" " + hours) : "");
		},
		formatMoney(m, c=2, d=',', t='.') {
		  var number = parseFloat(m, 10);
		  var tmp = number.toFixed(c).toString().split(".")
		  var main_number = tmp[0];
		  var leftover = tmp[1] ? tmp[1] : '';
		  var i = 0;
		  var final_number = "";
		  while (true) {
		    if (main_number[i] === undefined) break;
		    if ((main_number.length - i) % 3 === 0 && final_number.length)
		      final_number += t;
		    final_number += main_number[i];
		    i++;
		  }
		  return final_number + (leftover.length && leftover!='00' ? (d + leftover) : '');
		}
	},
}
